"use client";

import type { EventParams } from "@/utils/analytics";

const TRIAL_EXTERNAL_BASE = "https://searchright-trial-hw.vercel.app";
const TRIAL_TRACK_URL = `${TRIAL_EXTERNAL_BASE}/api/track`;
const TRIAL_SESSION_ID_KEY = "sr_trial_session_id";
const SESSION_START_FLAG_KEY = "sr_trial_session_started";

export function getOrCreateTrialSessionId(): string {
  if (typeof window === "undefined") return "";
  let id = sessionStorage.getItem(TRIAL_SESSION_ID_KEY);
  if (!id) {
    id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(TRIAL_SESSION_ID_KEY, id);
  }
  return id;
}

export function trackTrialEvent(type: string, data?: EventParams) {
  if (typeof window === "undefined") return;
  const sessionId = getOrCreateTrialSessionId();
  if (!sessionId) return;

  try {
    fetch(TRIAL_TRACK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sessionId, type, data }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}

export function ensureTrialSessionStarted(data?: EventParams) {
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem(SESSION_START_FLAG_KEY)) return;
  sessionStorage.setItem(SESSION_START_FLAG_KEY, "1");
  trackTrialEvent("session_start", data);
}
